import React from 'react'

import {
  AlignItems,
  FlexBox,
  FlexDirection,
  FontWeight,
  Heading,
  HeadingElement,
  InfluxColors,
  JustifyContent,
} from '@influxdata/clockface'

interface Props {
  text: string
  title: string
}

const PlanCardBanner = ({text, title}: Props): JSX.Element => {
  return (
    <div className="plan-card-banner--section">
      <FlexBox
        alignItems={AlignItems.Center}
        direction={FlexDirection.Column}
        justifyContent={JustifyContent.Center}
        style={{height: '100%', color: InfluxColors.Basalt}}
        className="plan-card-banner--content"
      >
        <Heading element={HeadingElement.H4} weight={FontWeight.Regular}>
          {title}
        </Heading>
        <p className="plan-card-banner--details">{text}</p>
      </FlexBox>
      <div className="plan-card-banner--bottom-left" />
      <div className="plan-card-banner--bottom-right" />
    </div>
  )
}

export default PlanCardBanner
